export default function Home() {
  return (
    <div className="bg-black text-gray-200 dosis">
      {/* HERO SECTION */}
      <section className="relative h-[80vh] md:h-screen flex flex-col justify-center items-center text-center overflow-hidden">
        {/* Hero background */}
        <img
          src="/hero.jpg"
          alt="Tattoo background"
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black"></div>

        {/* Content */}
        <div className="relative z-10 max-w-3xl px-6 md:px-10 animate-fade-in pt-[120px]">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-heading text-white text-chrome mb-4 md:mb-6 uppercase">
            Art that lasts forever
          </h1>
          <p className="text-gray-400 text-base sm:text-lg mb-6 md:mb-8 tracking-widest">
            Custom tattooing by{" "}
            <span className="text-chrome">Greg Cameron</span> — bold designs,
            clean lines, Derby based.
          </p>
          <a
            href="mailto:bookings@throttledink.com"
            className="bg-white hover:bg-transparent text-black hover:border hover:text-white font-semibold px-6 py-2 sm:px-8 sm:py-3 rounded uppercase transition"
          >
            Book a Session
          </a>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="bg-white text-black py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 items-center gap-12">
          <div className="overflow-hidden rounded-xl shadow-lg">
            <img
              src="/about.png"
              alt="Greg Cameron tattooist at work"
              className="w-full h-full object-cover transform hover:scale-105 transition duration-700"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-4xl font-heading dosis">About Greg</h2>
            <p className="text-gray-700 leading-relaxed">
              Based in Derby, <strong>Greg Cameron</strong> is a solo artist
              studio renowned for precision, creativity, and an unfiltered
              passion for custom tattooing. With over{" "}
              <strong>9 award wins</strong> and years of experience in the
              industry, every session is a collaboration — where your ideas meet
              bold execution.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Each design is delivered with technical mastery, ensuring that
              every client leaves with a piece of art that stands the test of
              time.
            </p>
            <br />
            <br />
            <a
              href="mailto:info@throttledink.com"
              className="bg-chrome bg-black hover:bg-transparent hover:border hover:text-black text-white font-semibold px-8 py-3 rounded uppercase transition dosis"
            >
              Book a Session
            </a>
          </div>
        </div>
      </section>

      {/* SOCIAL LINKS SECTION */}
      <section className="bg-black text-center py-16 border-t border-gray-800">
        <h3 className="text-chrome font-heading text-3xl mb-4 uppercase tracking-wider">
          Follow the Journey
        </h3>

        <p className="text-gray-400 max-w-xl mx-auto mb-8 text-lg">
          Greg Cameron works out of{" "}
          <span className="text-chrome font-semibold">
            Collective Tattoo Studio
          </span>{" "}
          in Derby
        </p>

        <div className="flex flex-col items-center gap-4">
          {/* Instagram icon */}
          <img
            src="/instagram.png"
            alt="Instagram logo"
            className="w-6 h-6 mx-auto opacity-90 hover:opacity-100 transition duration-300"
          />

          {/* Links */}
          <div className="flex flex-col justify-center gap-2 text-lg">
            <a
              href="https://www.instagram.com/throttled_ink"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition underline"
            >
              @throttled_ink
            </a>
            <a
              href="https://www.instagram.com/c.o.l.l.e.c.t.i.v.e_tattoo"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition underline"
            >
              @c.o.l.l.e.c.t.i.v.e_tattoo
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
